import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"


import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/gucangSales/analysis'
import { listByParamCodes } from '@/api/common'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { alarmTypeEnum, alarmLevelEnum, alarmCustomerLevelEnum, alarmProcessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
const __default__ = { name: 'fbu_followChangeFeedback' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const searchFrom = ref<FollowAlarmParams>({})
const paramCodeData = ref<any>({
  fbu_change_description: [] // 异动说明
})
const columns = computed(() => [
  {
    title: '主客户代码',
    dataIndex: 'customerNumber',
    fixed: 'left',
    width: 150
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName'
  },
  {
    title: '异动触发时间',
    dataIndex: 'alarmDate'
  },
  {
    title: '异动级别',
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: '客户量级',
    dataIndex: 'customerLevel',
    dicData: alarmCustomerLevelEnum
  },
  {
    title: '异动类型',
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: '异动原因',
    dataIndex: 'alarmInfo'
  },
  {
    title: '异动说明',
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.fbu_change_description
  },
  {
    title: '具体详情',
    dataIndex: 'process'
  },
  {
    title: '反馈时间',
    dataIndex: 'processTime'
  },
  {
    title: '反馈情况',
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  followAlarmGet({
    ...params
  }).then((res) => {
    callBack(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            tableId: "fbuFollowChangeFeedback"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "主客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerNumber) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.arkCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.arkCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "createTime",
                    label: "异动触发时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.startAlarmDate,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.startAlarmDate) = $event)),
                        endTime: searchFrom.value.endAlarmDate,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.endAlarmDate) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "seller",
                    label: "客户负责人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.seller,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "异动类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.alarmType,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.alarmType) = $event)),
                        placeholder: "请选择",
                        allowClear: "",
                        options: _unref(alarmTypeEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "异动级别" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.alarmLevelList,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.alarmLevelList) = $event)),
                        placeholder: "请选择",
                        mode: "multiple",
                        allowClear: "",
                        options: _unref(alarmLevelEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "反馈情况" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.processStatusList,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.processStatusList) = $event)),
                        placeholder: "请选择",
                        allowClear: "",
                        mode: "multiple",
                        options: _unref(alarmProcessStatusEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "213",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_followChangeFeedback_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (column.dataIndex === 'process')
                ? (_openBlock(), _createBlock(EditorTableText, {
                    key: 0,
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})